import { useContext, useState } from "react";

import Box from "@mui/material/Box";
import CheckIcon from '@mui/icons-material/Check';
import Container from "@mui/material/Container";
import CustomButton from "../components/CustomButton";
import CustomContainer from "../components/CustomContainer";
import CustomTextField from "../components/CustomTextField";
import DashboardContext from "../context/DashboardContext";
import Divider from "@mui/material/Dialog";
import FileUploadIcon from '@mui/icons-material/FileUpload';
import Input from "@mui/material/Input";
import InputAdornment from "@mui/material/InputAdornment";
import PreviewIcon from '@mui/icons-material/Preview';
import SettingsIcon from '@mui/icons-material/Settings';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";


export default function Settings() {
  const {
    primaryColorInputHandler,
    primaryColorSubmit,
    primaryColorInput,
    colorInputError,
  } = useContext(DashboardContext);

  return (
    <Container>
      <CustomContainer sx={{ minWidth: 1100, py: 4 }}>
        <Typography
          color="primary"
          component="h2"
          mb={4}
          sx={{
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
          variant="h4"
        >
          <SettingsIcon fontSize="md" sx={{ mr: 1 }} />
          Configurações
        </Typography>
        <Stack spacing={3}>
          <Box sx={{ display: "flex" }}>
            <Typography
              color="primary"
              component="h2"
              mb={1}
              mr={4}
              pl={2}
              variant="h6"
            >
              Cor de destaque da página:
            </Typography>

            <form onSubmit={ primaryColorSubmit }>
              <CustomTextField
                color="primary"
                error={ colorInputError }
                helperText={ colorInputError && "O código da cor deve possuir 6 caracteres" }
                InputProps={{
                  startAdornment: <InputAdornment position="start">#</InputAdornment>,
                }}
                label="Cor em Hexadecimal"
                onChange={ primaryColorInputHandler }
                size="small"
                sx={{ width: "180px" }}
                value={ primaryColorInput }
                variant="outlined"
              />

              <CustomButton
                variant="contained"
                color="primary"
                endIcon={<CheckIcon />}
                sx={{ ml: 2 }}
                type="submit"
              >
                Aplicar
              </CustomButton>
            </form>
          </Box>

          <Divider />

          <Box sx={{ display: "flex" }}>
            <Typography
              color="primary"
              component="h2"
              mr={4}
              pl={2}
              variant="h6"
            >
              Imagem de capa:
            </Typography>

            <label htmlFor="contained-button-file">
              <Input accept="image/*" id="contained-button-file" multiple type="file" sx={{ display: "none" }} />
              <CustomButton component="span" disabled endIcon={<FileUploadIcon />} variant="contained">
                Carregar arquivo
              </CustomButton>
            </label>

            <CustomButton
              color="primary"
              disabled
              endIcon={<PreviewIcon />}
              // onClick={  }
              sx={{ ml: 4}}
              variant="outlined"
            >
              Visualizar atual
            </CustomButton>
          </Box>

          <Divider />

          <Box sx={{ display: "flex" }}>
            <Typography
              color="primary"
              component="h2"
              mr={4}
              pl={2}
              variant="h6"
            >
              Imagem da logo:
            </Typography>

            <label htmlFor="contained-button-file">
              <Input accept="image/*" id="contained-button-file" multiple type="file" sx={{ display: "none" }} />
              <CustomButton component="span" disabled endIcon={<FileUploadIcon />} variant="contained">
                Carregar arquivo
              </CustomButton>
            </label>

            <CustomButton
              color="primary"
              disabled
              endIcon={<PreviewIcon />}
              // onClick={  }
              sx={{ ml: 4}}
              variant="outlined"
            >
              Visualizar atual
            </CustomButton>
          </Box>
        </Stack>
      </CustomContainer>
    </Container>
  );
};
